import Navigation from '../../../../components/layout/Navigation';
import Footer from '../../../../components/layout/Footer';
import Hero from '../../../../components/ui/Hero';
import Section from '../../../../components/ui/Section';
import FeatureGrid from '../../../../components/ui/FeatureGrid';
import ProcessTimeline from '../../../../components/ui/ProcessTimeline';
import CTA from '../../../../components/ui/CTA';

export default function GraphicMotionDesignPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-purple-800 to-pink-800 text-white overflow-x-hidden">
      <Navigation />
      
      <Hero 
        title={<>Where Creativity Takes Flight,<br /><span className="bg-gradient-to-r from-pink-400 to-purple-300 bg-clip-text text-transparent">Statically & Dynamically</span></>}
        description="We craft stunning graphic designs and captivating motion visuals that bring your brand's story to vibrant life."
        bgImage="/assets/modern-creative-studio.png"
        primaryBtn={{ text: "Start Visual Project", link: "/contact", icon: "ri-palette-line" }}
        secondaryBtn={{ text: "View Portfolio", link: "/work", icon: "ri-play-circle-line" }}
      />

      <Section>
        <FeatureGrid 
          title={<>The Art of <span className="bg-gradient-to-r from-pink-400 to-purple-500 bg-clip-text text-transparent">Visual Storytelling</span></>}
          subtitle="Effective graphic design arranges images, typography, and colors to convey a message and evoke emotion. Motion design takes this further by animating these elements."
          items={[
            { title: 'Clarity & Purpose', description: 'Each element serves a clear objective.', icon: 'ri-focus-line', color: 'from-blue-500 to-purple-600' },
            { title: 'Brand Consistency', description: 'Designs align with your brand identity.', icon: 'ri-shield-check-line', color: 'from-green-500 to-teal-600' },
            { title: 'Engagement & Appeal', description: 'Visuals that grab attention.', icon: 'ri-heart-pulse-line', color: 'from-orange-500 to-red-600' },
            { title: 'Versatility', description: 'Designs that work across platforms.', icon: 'ri-layout-grid-line', color: 'from-pink-500 to-purple-600' },
            { title: 'Narrative Flow', description: 'Movement guiding the viewer through a story.', icon: 'ri-movie-2-line', color: 'from-indigo-500 to-blue-600' }
          ]}
        />
      </Section>

      <Section className="bg-gray-900">
        <ProcessTimeline 
          title="From Concept to Captivation"
          subtitle="Our process is collaborative and tailored to your needs, ensuring every design meets your strategic goals."
          steps={[
            { title: 'Discovery', description: 'Gathering details on your goals & audience.', icon: 'ri-search-line', color: 'from-purple-500 to-pink-500' },
            { title: 'Concept', description: 'Exploring creative concepts & storyboards.', icon: 'ri-lightbulb-line', color: 'from-pink-500 to-red-500' },
            { title: 'Design', description: 'Creating static visuals or animations.', icon: 'ri-palette-line', color: 'from-red-500 to-orange-500' },
            { title: 'Refinement', description: 'Refining based on your feedback.', icon: 'ri-refresh-line', color: 'from-orange-500 to-yellow-500' },
            { title: 'Delivery', description: 'Providing optimized high-res files.', icon: 'ri-download-line', color: 'from-yellow-500 to-green-500' }
          ]}
        />
      </Section>

      <Section>
        <FeatureGrid 
          title="Perfect for Businesses Looking to Communicate Effectively"
          subtitle="Our services are essential for businesses looking to communicate effectively in today's digital age."
          items={[
            { title: 'Digital Marketers', description: 'Social media, ads, and email campaigns.', icon: 'ri-megaphone-line', color: 'from-pink-500 to-purple-600' },
            { title: 'Content Creators', description: 'Blogs, articles, and presentations.', icon: 'ri-article-line', color: 'from-purple-600 to-indigo-600' },
            { title: 'E-commerce', description: 'Product visuals and promo videos.', icon: 'ri-shopping-cart-line', color: 'from-indigo-600 to-blue-600' },
            { title: 'Corporate Brands', description: 'Presentations and reports.', icon: 'ri-building-line', color: 'from-blue-600 to-cyan-600' },
            { title: 'Startups', description: 'Pitch decks and brand identity.', icon: 'ri-rocket-line', color: 'from-cyan-600 to-teal-600' }
          ]}
          columns={3}
        />
      </Section>

      <CTA 
        title={<>Let's Create Visuals That <span className="bg-gradient-to-r from-pink-400 to-purple-300 bg-clip-text text-transparent">Speak Volumes</span></>}
        description="Partner with Hash Adz to transform your ideas into captivating graphic and motion designs."
        primaryBtn={{ text: "Start Project", link: "/contact" }}
        secondaryBtn={{ text: "View Portfolio", link: "/work" }}
        stats={[
          { number: '300+', label: 'Visual Projects' },
          { number: '98%', label: 'Satisfaction' },
          { number: '50+', label: 'Industries' }
        ]}
      />

      <Footer />
    </div>
  );
}